<template>
  <div>
    <div class="titles">
      查看领取权限
      <Icon type="ios-redo" size="25" class="auth01" @click="back"/>
    </div>
    <div class="ckq01" v-for="(item,index) in data" :key="'ckl'+index">
      <div class="ckq02">{{item.devicename}}</div>
      <div class="ckq03">
        <div class="ckq04">
          <div class="ckq05" v-for="(ite,ind) in item.data" :key="'jds'+ind">{{ite.goodsname}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from '@/api/user';
  export default {
    name: "djgqx",
    data(){
      return{
        data:[],
        userId:'',
        companyId:'',
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      me.userId = me.$route.query.userId;
      me.companyId = me.$route.query.companyId;
      let data = {
        userid:me.userId,
        companyid:me.companyId,
      }
      httpUser.seaLqqx(data).then(res => {
        console.log(res);
        me.data = res.data.datalist;
      })
    },
    methods:{
      back(){
        me.$router.back();
      }
    }
  }
</script>

<style scoped>
@import "user.css";
</style>